import type { ExternalTableSchema } from '@packages/table-builder';

export const taxCertificationDocumentsTable: ExternalTableSchema = {
  metadata: {
    title: 'Tax Certificates',
    entity: 'tax-certification-documents',
  },
  dataSource: {
    endpoint: '/api/customer/api/broker-participant-info/{particiantId}/certification-documents',
    method: 'GET',
    rowIdField: 'taxCertificationId',
    pathParams: { particiantId: 'particiantId' },
  },
  features: {
    pagination: { mode: 'none' },
    search: { enabled: false },
    columnPreferences: {
      persistenceKey: 'taxCertificationDocuments',
      resizable: true,
      reorderable: true,
    },
  },
  columns: [
    { field: 'certificationDate', header: 'Certification Date', type: 'date', width: 220 },
    { field: 'type', header: 'Type', type: 'text', width: 200 },
    {
      field: 'taxCertification',
      header: 'Tax Certificate',
      type: 'text',
      width: 180,
      align: 'center',
      actionIntent: {
        actionId: 'VIEW_TAX_CERTIFICATE_DOCUMENT',
        payload: { taxCertification: 'taxCertification' },
        whenHasValue: false,
        label: 'View Tax Certificate',
      },
    },
  ],
};
